import React from 'react';

// components
import { Canvas } from './canvas';
import { Modal, ModalContent } from 'shared/components/bulma/modal';

// pipes
import { titleCasePipe } from 'shared/pipes';

const ModalReportView = ({ modal, handleModal, report = {} }) => {
    const { barcode, comment, location, type } = report;

    const values = ["stain", "broken", "button_missing"];
    const checkboxes = {};
    for (const value of values) {
        checkboxes[value] = report.type.includes(value);
    }

    const Types = () => {
        return type.map((v) => (
            <span key={v} className="tag mr-2 is-medium is-light">{titleCasePipe.transform(v)}</span>
        ));
    }

    return (
        <Modal onExit={handleModal} isActive={modal} title={barcode}>
            <ModalContent>
                <div className="field my-3">
                    <label className="label">Location</label>
                    <Canvas disabled={true} data={location} width={600} height={200} />
                </div>

                <div className="content">
                    <label className="label">Comment</label>
                    <p>{comment}</p>
                </div>

                <label className="label">Details</label>
                <Types />
            </ModalContent>
        </Modal>
    );
}

export { ModalReportView };
